import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-valid-dialog',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './valid-dialog.component.html',
  styleUrl: './valid-dialog.component.scss',
})
export class ValidDialogComponent {
  private readonly loggingService = inject(LoggingService);
  
  constructor(
    public dialogRef: MatDialogRef<ValidDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      firstName: boolean;
      lastName: boolean;
      phone: boolean;
      phonePattern: boolean;

      carNumber: boolean;
      province: boolean;
      bandCar: boolean;
      modelCar: boolean;
      colorCar: boolean;

      dateTyre: boolean;
      provinceStoreMain: boolean;

      locationStore: boolean;
      bandStore: boolean;
      provinceStore: boolean;

      addressStore: boolean;
      postal: boolean;
      img: boolean;
      // franchiseCar: boolean;
      agreementAccept: boolean;
      checkPatternEmail: boolean;
      //ชื่อร้านตัวแทนจำหน่ายอย่างเป็๋นทางการ
      //
    } // private cdr: ChangeDetectorRef // data: { name: string; lastname: string }
  ) {
    this.loggingService.log(data);
    // this.cdr.detectChanges();
  }
}
